import { Typography, colors, Grid, Hidden, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.primary.dark,
    minHeight: '98px'
  },

  footerLinkGroup: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },

  footerLinkItem: {
    padding: theme.spacing(0.8),
    paddingTop: '0px',
    display: 'inline-block'
  },
  companyText: {
    textAlign: 'center'
  },
  text: {
    color: colors.blue[100],
    letterSpacing: theme.spacing(0.05),
    textTransform: 'none',
    '&:hover': {
      color: theme.palette.white
    }
  },
  button: {
    minWidth: '20px',
    fontSize: '12px',
    justifyContent: 'center',
    padding: '0',
    margin: '0',
    width: '100%'
  }
}))

const Footer = props => {
  const { className, ...rest } = props
  const classes = useStyles()
  const footerLinkItems = [
    {
      name: 'All Meeting Rooms',
      url: 'https://meetingpackage.com/all-meeting-rooms'
    },
    { name: 'All Venues', url: 'https://meetingpackage.com/all-venues' },
    {
      name: 'Affiliate Program',
      url: 'https://affiliates.meetingpackage.com/'
    },
    { name: 'Blog', url: 'https://blog.meetingpackage.com/' },
    { name: 'Contact', url: 'https://meetingpackage.com/contact/' },
    { name: 'Terms of Service', url: 'https://meetingpackage.com/terms/' },
    {
      name: 'Privacy Policy',
      url: 'https://meetingpackage.com/privacy-policy/'
    },
    {
      name: 'Data Processing & General Terms',
      url: 'https://meetingpackage.com/data-processing-and-general-terms/'
    },
    { name: 'Register', url: 'https://meetingpackage.com/user/register' },
    { name: 'Login', url: 'https://meetingpackage.com/user/login' }
  ]
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Hidden xsDown>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="flex-start">
          <Grid item xl={9} sm={10} xs={12}>
            <div className={classes.footerLinkGroup}>
              {footerLinkItems.map(item => (
                <div key={item.name} className={classes.footerLinkItem}>
                  <Button
                    variant="text"
                    color="inherit"
                    className={classes.button}
                    href={item.url}>
                    <Typography variant="caption" className={classes.text}>
                      {item.name}
                    </Typography>
                  </Button>
                </div>
              ))}
            </div>
          </Grid>
          <Grid item xl={3} sm={2} xs={12}>
            <div className={classes.companyText}>
              <Typography variant="caption" className={classes.text}>
                © 2018 Cocouz Oy Ltd.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="flex-start">
          {footerLinkItems.map(item => (
            <Grid item key={item.name} xs={6}>
              <Typography variant="subtitle1" className={classes.text}>
                <a className={classes.text} href={item.url}>
                  ‣ {item.name}
                </a>
              </Typography>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              className={classes.text}
              style={{ float: 'right' }}>
              © 2018 Cocouz Oy Ltd.
            </Typography>
          </Grid>
        </Grid>
      </Hidden>
    </div>
  )
}

Footer.propTypes = {
  className: PropTypes.string
}

export default Footer
